import React from 'react';
import { Box } from '@neta';

const stopPropagation = e => e.stopPropagation();

export default class SelectItem extends React.Component {
  render() {
    const { item, index, getItemProps, highlightedIndex, selectedItem } = this.props;
    const isActive = highlightedIndex === index;
    const isSelected = selectedItem === item.value;
    const value = item.value || item;
    const name = item.name || item;
    let itemProps = null;
    try {
      itemProps = getItemProps({ index, item, onClick: stopPropagation });
    } catch (e) {
      // console.log({ e });
    }
    return (
      <Box
        {...itemProps}
        key={value}
        py={2}
        px={3}
        fontWeight={isSelected ? 'bold' : 'inherit'}
        bg={isActive ? 'grayscale.lightGray' : 'inherit'}
        style={{ cursor: 'pointer' }}
      >
        {name}
      </Box>
    );
  }
}
